import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type LayoutedOverlayFooterColor = 'yellow' | 'violet';

@Component({
  standalone: false,
  selector: 'ssc-layouted-overlay',
  templateUrl: './layouted-overlay.component.html',
  styleUrls: ['./layouted-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutedOverlayComponent {
  @Input() public title: string;
  @Input() public subtitle: string;
  @Input() public highlightFooter?: LayoutedOverlayFooterColor;
  @Input() public mode: 'narrow' | 'wide' = 'narrow';

  @Output() public closed = new EventEmitter();
}
